
<div class="new-alert-notification">
  <app-fn-ui-close-icon size="19px" (closeClick)="remove()"></app-fn-ui-close-icon>
  <div>
    <span
      class="message">{{ 'alert.message.new-alerts' | translate: {count: count | number: '2.'} }}</span>
  </div>
</div>